<template>
  <va-card :title="$t('tables.employees')">
    <template slot="actions">
      <va-button icon="fa fa-refresh" color="info" @click="refresh()" :disabled="loading == true"/>
      <va-button icon="fa fa-gear" color="info" :disabled="loading == true" />
      <va-button icon="fa fa-plus" color="info" :disabled="loading == true" @click="add()"/>
    </template>
    <div class="row align--center mb-1">
      <div class="flex xs12 sm6">
        <va-input
          class="ma-0"
          :value="term"
          :placeholder="$t('search.searchByFamilyName')"
          @input="search"
        >
          <va-icon name="fa fa-search" slot="prepend" />
        </va-input>
      </div>
      <div class="flex xs12 sm6">
        <va-checkbox v-model="includeInactive" label="Show inactive employees" :disabled="loading == true"></va-checkbox>
      </div>
    </div>
    <div class="row">
      <div class="flex xs12">
        <div class="row">
          <div class="flex xs12">
            <va-data-table
              :fields="fields"
              :data="filteredData"
              :per-page="15"
              clickable
              :loading="loading"
              hoverable
            >
              <template slot="icon">
                <va-icon name="fa fa-user" color="secondary" />
              </template>
              <template slot="status" slot-scope="props">
                <va-badge
                  :color="getBadgeColor(props.rowData.inactive)"
                >{{ getBadgeText(props.rowData.inactive) }}</va-badge>
              </template>
              <template slot="actions" slot-scope="props">
                <va-button
                  flat
                  small
                  color="info"
                  icon="iconicstroke iconicstroke-mail"
                  @click="sendInvitation(props.rowData)"
                />
                <va-button
                  flat
                  small
                  color="info"
                  icon="fa fa-pencil"
                  @click="editItem(props.rowData)"
                />
                <va-button
                  flat
                  small
                  color="danger"
                  icon="fa fa-trash"
                  @click="deleteItem(props.rowData)"
                />
              </template>
            </va-data-table>
          </div>
        </div>
      </div>
    </div>
    <div class="modals">
      <div class="flex xs12">
        <va-modal
          size="large"
          max-width="100%"
          v-model="editDialog"
          :title=" $t('modal.editTitle') "
          cancelClass="none"
          :okText=" $t('modal.confirm') "
          :message="message"
          noOutsideDismiss
          noEscDismiss
          @cancel="close"
          @ok="save"
        >
          <div class="form-elements">
            <form>
              <div class="row">
                <div class="flex xs12">
                  <va-input
                    v-model="editedItem.name"
                    placeholder="Employee Name"
                    label="Employee Name"
                  ></va-input>
                </div>
              </div>
              <div class="row">
                <div class="flex xs12">
                  <va-input
                    v-model="editedItem.family"
                    placeholder="Employee Family Name"
                    label="Employee Family Name"
                  ></va-input>
                </div>
              </div>
              <div class="row">
                <div class="flex xs12">
                  <va-input
                    v-model="editedItem.email_address"
                    type="email"
                    label="Email Address"
                    placeholder="Email Address"
                    success
                  ></va-input>
                </div>
              </div>
              <div class="row">
                <div class="flex xs12">
                  <va-checkbox v-model="editedItem.inactive" label="Inactive"></va-checkbox>
                </div>
              </div>
            </form>
          </div>
        </va-modal>
      </div>
    </div>
  </va-card>
</template>

<script>
import employeeService from '../../../api/employeeService'
import dataFactory from '../../../api/dataFactoryService'
import { debounce } from 'lodash'

export default {
  data () {
    return {
      loading: false,
      editDialog: false,
      deleteDialog: false,
      employees: [],
      editedIndex: -1,
      message: '',
      term: null,
      includeInactive: false,
      editedItem: {
        id: '',
        name: '',
        family: '',
        invitation_sent: false,
        external_id: '',
        emai_verified: false,
        full_name: '',
        email_addres: '',
        inactive: false,
        role: {
          employee: true,
          manager: false,
          super_admin: false,
          admin: false,
        },
      },
      defaultItem: {
        id: '',
        name: '',
        family: '',
        invitation_sent: false,
        external_id: '',
        emai_verified: false,
        full_name: '',
        email_addres: '',
        inactive: false,
        role: {
          employee: true,
          manager: false,
          super_admin: false,
          admin: false,
        },
      },
    }
  },
  computed: {
    filteredData () {
      if (!this.term || this.term.length < 1) {
        return this.employees.filter(item => {
          return item.inactive === this.includeInactive
        })
      }
      return this.employees.filter(item => {
        return item.inactive === this.includeInactive && item.family
          .toLowerCase()
          .includes(this.term.toLowerCase())
      })
    },
    fields () {
      return [
        {
          name: '__slot:icon',
          width: '30px',
          dataClass: 'text-center',
        },
        {
          name: 'name',
          title: this.$t('tables.employeeHeadings.name'),
          sortField: 'name',
          width: '15%',
        },
        {
          name: 'family',
          title: this.$t('tables.employeeHeadings.family'),
          sortField: 'family',
          width: '15%',
        },
        {
          name: '__slot:status',
          title: this.$t('tables.employeeHeadings.inactive'),
          width: '10%',
        },
        {
          name: 'email_address',
          title: this.$t('tables.employeeHeadings.email'),
          sortField: 'email_address',
          width: '20%',
        },
        {
          name: '__slot:actions',
          dataClass: 'text-right',
        },
      ]
    },
  },

  watch: {
    editDialog (val) {
      // val || this.close()
      if (val) {
        console.log('close called')
      }
    },
  },

  async created () {
    await this.initialize()
  },

  methods: {
    search: debounce(function (term) {
      this.term = term
    }, 400),
    getBadgeColor (inactive) {
      if (inactive === true) {
        return 'danger'
      } else {
        return 'info'
      }
    },
    getBadgeText (inactive) {
      if (inactive === true) {
        return 'inactive'
      } else {
        return 'active'
      }
    },
    async refresh () {
      await this.initialize()
      console.log('refresh')
    },
    emailMessage (item) {
      if (item === undefined) {
        return ''
      }
      if (item.invitation_sent) {
        return 'Invitation email resent to ' + item.full_name
      } else {
        return 'Invitation email sent to ' + item.full_name
      }
    },
    async sendInvitation (item) {
      try {
        await employeeService.sendInvitation(item.id)
        item.invitation_sent = true
        this.showToast(this.emailMessage(item), {
          icon: 'fa-check',
          position: 'bottom-right',
          duration: 3000,
        })
      } catch (error) {
        this.showToast(error, {
          icon: 'fa-exclamation',
          position: 'bottom-right',
          duration: 5000,
        })
      }
    },
    async initialize () {
      this.loading = true
      try {
        let employeeResult = await employeeService.getActive()
        this.employees = dataFactory.createEmployeeListModel(
          employeeResult.payload.data
        )
      } catch (error) {
        this.showToast(error, {
          icon: 'fa-exclamation',
          position: 'bottom-right',
          duration: 5000,
        })
      }
      this.loading = false
    },

    editItem (item) {
      this.editedIndex = this.employees.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editDialog = true
      this.message = "Edit the selected employee. Make sure the employee's email is unique in system."
    },

    async deleteItem (item) {
      const index = this.employees.indexOf(item)
      if (confirm('Are you sure you want to delete this item?')) {
        try {
          await employeeService.delete(item.id)
          this.employees.splice(index, 1)
        } catch (error) {
          this.showToast(error, {
            icon: 'fa-exclamation',
            position: 'bottom-right',
            duration: 5000,
          })
        }
      }
    },

    close () {
      this.editDialog = false
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
    },

    async save () {
      try {
        this.loading = true
        if (this.editedIndex > -1) {
          await employeeService.update(this.editedItem.id, this.editedItem)
          this.employees[this.editedIndex] = Object.assign(this.employees[this.editedIndex], this.editedItem)
        } else {
          var creationResult = await employeeService.create(this.editedItem)
          this.editedItem.id = creationResult.payload.data
          this.employees.push(this.editedItem)
        }
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      } catch (error) {
        this.showToast(error, {
          icon: 'fa-exclamation',
          position: 'bottom-right',
          duration: 5000,
        })
      }
      this.loading = false
      this.editDialog = false
    },

    add () {
      this.editDialog = true
      this.message = "Add a new empolyee to the system. Make sure the employee's email is unique in system."
    },
  },
}
</script>

<style lang="scss">
</style>
